import { INVITATION_STATUS } from './constants'

export default {
  getInvitationStatus() {
    return status => {
      return (
        INVITATION_STATUS[status] ?? {
          title: status,
          color: INVITATION_STATUS.accepted.color
        }
      )
    }
  }
}
